import {LayoutType} from '../graphql/generated/types';
import {SectionEntity} from '../pagewebLayout/types';
import {AppState} from '../state/store';

export function selectIsSubtab({
  section,
  state,
}: {
  section: SectionEntity;
  state: AppState;
}) {
  const layoutId = state.pagewebLayout.relations.sections[section.id].parentId;
  return (
    state.pagewebLayout.entities.layouts[layoutId].type === LayoutType.Layout
  );
}
